// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","header1":"Header_header1__2EoQM","title":"Header_title__3SH2Q"};